import { teApi } from 'yxt-biz-pc/packages/api';

// 讲师试卷列表
export const getTeList = (param) => {
  return teApi.post('/tutor/select', param);
};

// 获取讲师分类列表
export const getCatalogList = (showNoClassification) => {
  return teApi.get(`/catalog/list?type=1&showNoClassification=${showNoClassification}`);
};
